import { PhoneIphone, AccessTime, Email } from '@material-ui/icons';
import React, { useContext, useEffect, useState } from 'react';
import { BrowserRouter, NavLink } from 'react-router-dom';
import AppContext from '../../App/AppContext';
import { Navbar } from '../Root/Navbar';
import TreeImgLogo from '../../Components/_shared/treeImgesLogo';
import { useWindowSize } from '../Controls/ScreenResolution';
import MiniDrawer from '../Root/LeftDrawer';
import IdleTimeOutHandler from '../Root/sessionClose';
import { AppStorage } from '../Service/storage-service';
import NotificationListner from '../../App/NotificationListner';
import { getMessagesWithoutSignature_List } from '../Service/userDetails-service';
import DialogComp from '../Modal/dialogModal';
import { UserMsgModal } from './userMsgModal';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const shouldShowNotification = (portalSettings) => {
    const setting = portalSettings?.portalSettingWorkflowNotification;
    if (setting === 1) return true;
    if (setting === 0) return false;
    if (setting === 2) return true;

    return false;
};

const useStyles = makeStyles({
    dialogTitle: {
        '& .MuiDialogTitle-root': {
            background: '#1976d2',
            color: '#fff',
            padding: '0px 25px'
        }
    }
});

export let Header = (props) => {
    //     const { portalSettings, showTopNavAndMenu, loggedIn, isTopNav, getUserPreference, userRoles } = useContext(AppContext);
    // const [WindowWidths, WindowHeights] = useWindowSize();
    const classes = useStyles();
    const { portalSettings, showTopNavAndMenu, loggedIn, isTopNav, userRoles } = useContext(AppContext);
    const [WindowWidths] = useWindowSize();
    const [menuType, setMenuType] = useState('T');
    const img = !!portalSettings.portalSettingMainLogo ? portalSettings.portalSettingMainLogo : `${process.env.PUBLIC_URL}/${portalSettings.portalSettingLogo}`;
    const [isActive, setIsActive] = useState(true);
    const [isLogout, setLogout] = useState(false);
    const [userMsgState, setUserMsgState] = useState({ list: [] });
    let isCheckin = userRoles.includes('checkin');

    const navBarPreferences = () => {
        if (localStorage.getItem('_AppbarLocation_') && localStorage.getItem('_AppbarLocation_') !== 'undefined') {
            return localStorage.getItem('_AppbarLocation_');
        } else {
            return portalSettings.portalSettingMenuType;
        }
    };

    useEffect(() => {
        setMenuType(navBarPreferences());
    }, [localStorage.getItem('_AppbarLocation_')]);

    const alreadyShown = AppStorage.getUserAcknowledgementModal();

    useEffect(() => {
        const fetchMessages = async () => {
            if (loggedIn) {
                let res = await getMessagesWithoutSignature_List();
                setUserMsgState((st) => ({
                    ...st,
                    list: res.data.list,

                    showTechAssign: res.data.list.length > 0
                }));
            }
        };
        fetchMessages();
    }, [loggedIn]);

    const handleLogout = () => {
        AppStorage.performLogout();

        window.location = '/';
    };

    const HeaderUserMSGComp = (messageTitle) => {
        return (
            <Grid container style={{ padding: 0 }} className={classes.dialogTitle}>
                <Grid item>{messageTitle}</Grid>
            </Grid>
        );
    };

    return (
        <BrowserRouter>
            {AppStorage.isLoggedIn() && !isCheckin ? (
                <IdleTimeOutHandler
                    onActive={() => setIsActive(true)}
                    onIdle={() => setIsActive(false)}
                    onLogout={() => setLogout(true)}
                    Logout={handleLogout}
                />
            ) : null}

            <div className="header">
                {showTopNavAndMenu && (
                    <div
                        className="portal-info"
                        style={{
                            backgroundColor: portalSettings.portalHeaderBackgroundColour,
                            color: portalSettings.portalHeaderTextColour,
                            display: isTopNav === false ? 'none' : ''
                        }}
                    >
                        <NavLink to="/" className="branding-logo">
                            <img src={img} />
                        </NavLink>
                        {[
                            { text: 'Call US', value: portalSettings.portalSettingCallUs, icon: PhoneIphone, link: 'tel:' + portalSettings.callUs },
                            { text: 'Opening Time', value: portalSettings.portalSettingOpeningTime, icon: AccessTime },
                            {
                                text: 'Email US',
                                value: portalSettings.portalSettingEmailUs,
                                icon: Email,
                                link: 'mailto:' + portalSettings.portalSettingEmailUs + '?subject=eWIP Query',
                                isDynamicDisplay: true
                            }
                        ].map((c, i) => (
                            <div className={`info ${c.isDynamicDisplay ? 'nav-bar-icons' : ''}`} key={i}>
                                <div className="icon">
                                    <c.icon fontSize="large" />
                                </div>
                                <div className="key-value">
                                    <label>{c.text}</label>
                                    <label className="value">
                                        {c.link ? (
                                            <a href={c.link} style={{ textDecoration: 'none', color: 'inherit' }}>
                                                {c.value}
                                            </a>
                                        ) : (
                                            c.value
                                        )}
                                    </label>
                                </div>
                            </div>
                        ))}
                        {loggedIn && portalSettings.portalSettingeWIPEnabled && (
                            <div style={{ padding: '15px', marginRight: WindowWidths > 750 ? 30 : 0 }}>
                                <TreeImgLogo />
                            </div>
                        )}
                    </div>
                )}

                {!alreadyShown &&
                    userMsgState.list.map((msg, index) => (
                        <DialogComp
                            className={classes.dialogTitle}
                            key={msg.messageID}
                            title={HeaderUserMSGComp(msg.messageTitle)}
                            maxWidth="sm"
                            fullWidth
                            fullScreen
                            onClose={() => {
                                setUserMsgState({ list: [], showTechAssign: false });

                                AppStorage.setUserAcknowledgementModal(true);
                            }}
                        >
                            <UserMsgModal
                                message={msg}
                                onClose={() => {
                                    setUserMsgState((st) => ({
                                        ...st,
                                        list: st.list.filter((m) => m.messageID !== msg.messageID),
                                        showTechAssign: st.list.length - 1 > 0
                                    }));
                                    if (userMsgState.list.length === 1) {
                                        AppStorage.setUserAcknowledgementModal(true);
                                    }
                                }}
                            />
                        </DialogComp>
                    ))}
                {loggedIn && portalSettings.portalSettingeWIPEnabled && shouldShowNotification(portalSettings) && <NotificationListner />}
                {menuType === 'S' ? <MiniDrawer /> : <Navbar></Navbar>}
            </div>
        </BrowserRouter>
    );
};
